import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";

export class GetEmployeesGrantsCommand extends IRequestCommand<
  Array<EmployeeDto>,
  ErrorDetails,
  IGetEmployeesGrantsCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierId}/serviceTypes/employees';

  public override setParameters(parameters: IGetEmployeesGrantsCommandParameters) {
    if (parameters.serviceTypeId) {
      this._commandUrl = this._commandUrl + '?serviceTypeId='+parameters.serviceTypeId;
    } else {
      this._commandUrl = 'carriers/{carrierId}/serviceTypes/employees';
    }
    this._commandUrl = this._commandUrl.replace(
        '{carrierId}',
        parameters.carrierId.toString()
    );
  }
}

export interface IGetEmployeesGrantsCommandParameters extends ICommandParameters {
  carrierId: string;
  serviceTypeId?: string;
}

export interface EmployeeDto {
    areaId: number;
    areaName: string;
    id: number;
    lastName: string;
    name: string;
}